<template>
  <span v-b-tooltip.hover :title="formattedDateText">
    {{fromNowText}}
  </span>
</template>

<script>
  import {mapGetters} from 'vuex'
  export default {
    name: 'date-time-text',
    props: {
      date: {
        type: [String, Number],
        required: true
      },
      formattedDate: {
        type: String
      }
    },
    computed:{
      ...mapGetters(['userTimeZone'])
    },
    data() {
      return {
        momentInstance: null,
        fromNowText: '',
        formattedDateText: '',
        intervalPromise: null
      }
    },
    created() {
      this.momentInstance = this.moment.utc(this.date);
      if (this.formattedDate) {
        return this.formattedDate;
      }
      this.fromNowText = this.calculateFrontNowText();
      this.formattedDateText = this.momentInstance.tz(this.userTimeZone).format(this.momentInstance.localeData().longDateFormat('llll'));
    },
    mounted() {
      this.intervalPromise = setInterval(() => {
        this.fromNowText = this.calculateFrontNowText();
      }, 60000);
    },
    beforeDestroy() {
      clearInterval(this.intervalPromise);
    },
    methods: {
      calculateFrontNowText() {
        return this.momentInstance.fromNow();
      }
    }
  }
</script>
